import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, filter, take, takeUntil } from 'rxjs';
import { MailTemplateSendModel } from '../../models/mail/mail-template-send.model';
import { SendMailModel } from '../../models/mail/send-mail.model';
import { VetMemberModel } from '../../models/vet-users/vet-member.model';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { MailFacade } from '../../shared-new/store/mail/mail.facade';
import { MailTemplatesPopupComponent } from '../../mail/mail-templates/mail-templates-popup.component';
import swal from 'sweetalert2';
import { PreviewMailPopupComponent } from '../../mail/preview-mail-popup/preview-mail-popup.component';
import { PreviewMailModel } from '../../models/mail/preview-mail.model';
import { AutoNotifyBaseComponent } from '../../shared-new/components/auto-notify-base/auto-notify-base.component';
import { NotificationsService } from '../../services/notifications.service';
import { EventsEmitter } from '../../shared/event-emitter/EventEmitter';
import { NotificationTemplateComponent } from '../../shared/notification-template/notification-template.component';
@Component({
  selector: 'sale-send-email-sms-popup',
  templateUrl: './sale-send-email-sms-popup.component.html',
  styleUrls: ['./sale-send-email-sms-popup.component.scss']
})
export class SaleSendEmailSmsPopupComponent extends AutoNotifyBaseComponent implements OnInit {

  @Input() public data: any;
  public model: any;
  public formModel: SendMailModel;
  form: FormGroup;
  private file: File;
  @ViewChild('fileInput') el: ElementRef;

  @ViewChild('primaryRef', { static: false }) primaryRef!: NotificationTemplateComponent;
  @Output() sendDataToParent = new EventEmitter<any>();
  public isChangeReplyToEmailAddress: boolean = false;

  public closeResult = '';
  public attachFileName = 'Attach file';
  public replyToEmailAddressError: string;
  public orginalReplyToEmailAddress: string;
  public buttonLabel: string = "Send Notification";

  constructor(
    public readonly modal: NgbActiveModal,
    private readonly notificationService: NotificationsService,
    private formBuilder: FormBuilder,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private readonly modalService: NgbModal,
    protected override readonly eventEmitter: EventsEmitter
  ) {
    super(eventEmitter);
  }

  public ngOnInit(): void {
  
    const memberIds = this.data?.memberIds;
    const notificationType = this.data?.notificationType;

    this.notificationService.getVetMemberUsers(memberIds, notificationType).pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response != null) {
        const notificationData = JSON.parse(JSON.stringify(response));
        this.messageTemplate = { ...notificationData.messageTemplate };
        this.recipients = [...notificationData.recipients];
        this.setNotificationTemplateRef(this.primaryRef);
      }
    });

  }
  public onCancel() {
    this.modal.dismiss('cancel click');
  }
  public onSubmit() {
    this.data.notificationData = { recipients: this.getSelectedRecipients(), messageTemplate: this.messageTemplate };
    this.sendDataToParent.emit(JSON.stringify(this.data));    
  }
}
